export default [
  {
    path: '/regulation/abnormal',
    name: 'abnormal',
    meta: {
      title: '监管照片'
    },
    component: () =>
      import(/* webpackChunkName: "dynamicList" */ '@/views/regulation/abnormal.vue')
  },
  {
    path: '/regulation/abnormalImg',
    name: 'abnormalImg',
    meta: {
      title: '监管照片详情'
    },
    component: () =>
      import(/* webpackChunkName: "dynamicList" */ '@/views/regulation/abnormalImg.vue')
  },
  {
    path: '/regulation/operationAccount',
    name: 'supervise',
    meta: {
      title: '监控查询'
    },
    component: () =>
      import(/* webpackChunkName: "operationAccount" */ '@/views/regulation/supervise.vue')
  },
  {
    path: '/regulation/superviseVio',
    name: 'supervise',
    meta: {
      title: '监控视频'
    },
    component: () =>
      import(/* webpackChunkName: "operationAccount" */ '@/views/regulation/superviseVio.vue')
  },
  {
    path: '/regulation/delivery',
    name: 'delivery',
    meta: {
      title: '垃圾投递准确率'
    },
    component: () =>
      import(/* webpackChunkName: "dynamicList" */ '@/views/regulation/delivery.vue')
  },
  {
    path: '/regulation/irregularDelivery',
    name: 'irregularDelivery',
    meta: {
      title: '投递不规范监管'
    },
    component: () =>
      import(/* webpackChunkName: "dynamicList" */ '@/views/regulation/irregularDelivery.vue')
  },
  {
    path: '/regulation/irregularDeliveryImg',
    name: 'irregularDeliveryImg',
    meta: {
      title: '投递不规范监管详情'
    },
    component: () =>
      import(/* webpackChunkName: "dynamicList" */ '@/views/regulation/irregularDeliveryImg.vue')
  },
  {
    path: '/regulation/satisfaction',
    name: 'satisfaction',
    meta: {
      title: '居民满意度'
    },
    component: () =>
      import(/* webpackChunkName: "dynamicList" */ '@/views/regulation/satisfaction.vue')
  },
  {
    path: '/regulation/operation',
    name: 'operation',
    meta: {
      title: '运营监管查看'
    },
    component: () =>
      import(/* webpackChunkName: "dynamicList" */ '@/views/regulation/operation.vue')
  },
  {
    path: '/regulation/operationImg',
    name: 'operationImg',
    meta: {
      title: '运营监管查看图片'
    },
    component: () =>
      import(/* webpackChunkName: "dynamicList" */ '@/views/regulation/operationImg.vue')
  }
]
